import React from "react"
import { IntlProvider } from "react-intl"

import Footer from "../components/nav/Footer"
import Topbar from "../components/nav/Topbar"
import CookieProvider from "../context/Cookie/Provider"

// import initUtm from "../utils/utm"

function Layout({ isHomePage, children, locale, translationUri, postType }) {
  /* eslint-disable */
  const i18nMessages = require(`../languages/${locale}`)
  /* eslint-enable */
  // if(location)
  //   initUtm(location)

  return (
    <div className="global-wrapper" data-is-root-path={isHomePage}>
      <IntlProvider locale={locale.slice(0, 2)} messages={i18nMessages}>
        <CookieProvider>
          <Topbar
            locale={locale}
            postType={postType}
            translationUri={translationUri}
          />
          <main>{children}</main>
          <Footer locale={locale} />
          <div className="hidden">
            <link href="https://rsms.me/inter/inter.css" rel="stylesheet" />
            <link
              href="https://unpkg.com/boxicons@2.1.1/css/boxicons.min.css"
              rel="stylesheet"
            />
          </div>
        </CookieProvider>
      </IntlProvider>
    </div>
  )
}

export default Layout
